export const tr = {
    'not-found': 'Sonuç bulunamadı',
    'not-selected': 'Hiçbir değer seçilmedi',
    'search-placeholder': 'Denemeyi veya segmenti bul',
    'segment-targeting-disabled': 'Segmente göre hedefleme kapalı',
    title: 'Segmentlere göre hedefleme'
};
